var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var CMSController = /** @class */ (function () {
    function CMSController() {
    }
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates/{groupId}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {ProjectStructureTemplateDownloadDto[]}
    ******************************************************************************************************/
    CMSController.GetProjectStructureTemplates = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates/{groupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates/template/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ProjectStructureTemplateDownloadDto}
    ******************************************************************************************************/
    CMSController.GetProjectStructureTemplate = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates/template/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates" and http method "POST" to call the back-end.
    
        * @param {ProjectStructureTemplateUploadDto} dto
        * @returns {ProjectStructureTemplateDownloadDto}
    ******************************************************************************************************/
    CMSController.CreateProjectStructureTemplate = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {ProjectStructureTemplateUploadDto} dto
        * @returns {ProjectStructureTemplateDownloadDto}
    ******************************************************************************************************/
    CMSController.UpdateProjectStructureTemplate = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    CMSController.DeleteProjectStructureTemplate = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/members/{projectGroupId}" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    CMSController.GetProjectGroupMembers = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/{projectGroupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/members/{projectGroupId}/roles" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @returns {ExtendedDataCollection<RoleAssignment, UserShortInfoDownloadDto[]>}
    ******************************************************************************************************/
    CMSController.GetProjectGroupMembersWithRoles = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/{projectGroupId}/roles", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/members/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {RoleAssignment[]} assignments
        * @returns {UserDownloadDto[]}
    ******************************************************************************************************/
    CMSController.AssignProjectGroupRolesToUsers = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/members/{projectGroupId}/{userId}" and http method "DELETE" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} userId
        * @returns {UserShortInfoDownloadDto}
    ******************************************************************************************************/
    CMSController.RemoveProjectGroupMember = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/{projectGroupId}/{userId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/members/roles/{projectGroupId}/{userId}" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} userId
        * @returns {string}
    ******************************************************************************************************/
    CMSController.GetRolesOfProjectGroupMember = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/roles/{projectGroupId}/{userId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/check/projectId/{groupId}/{projectId}/{id?}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} projectId
        * @param {string} id
        * @returns {boolean}
    ******************************************************************************************************/
    CMSController.CheckProjectId = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/check/projectId/{groupId}/{projectId}/{id?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<ProjectGroupDownloadDto, string>}
    ******************************************************************************************************/
    CMSController.GetProjectGroups = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/{groupId}/{structureTemplateId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} structureTemplateId
        * @param {ProjectGroupUploadDto} dto
        * @param {File} image
        * @param {RoleAssignment[]} roleAssignments
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    CMSController.CreateProjectGroup = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        if (data.image)
            fd.append("image", data.image);
        if (data.roleAssignments !== undefined)
            fd.append("roleAssignments", JSON.stringify(data.roleAssignments));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/{groupId}/{structureTemplateId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {ProjectGroupUploadDto} dto
        * @param {File} image
        * @param {RoleAssignment[]} roleAssignments
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    CMSController.ChangeProjectGroup = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        if (data.image)
            fd.append("image", data.image);
        if (data.roleAssignments !== undefined)
            fd.append("roleAssignments", JSON.stringify(data.roleAssignments));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    CMSController.DeleteProjectGroup = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/file/{projectGroupId}" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @returns {FileEntryDownloadDto[]}
    ******************************************************************************************************/
    CMSController.GetFiles = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/{projectGroupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/filecount/{projectGroupId}" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @returns {number}
    ******************************************************************************************************/
    CMSController.GetFilesCount = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/filecount/{projectGroupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/file/media/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} path
        * @param {string} contentPostLocationId
        * @param {string[]} categoryIds
        * @param {MediaUploadDto} data
        * @param {boolean} isProjectOutput
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    CMSController.AddMediaFile = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        fd.append("contentPostLocationId", JSON.stringify(data.contentPostLocationId));
        if (data.categoryIds !== undefined)
            fd.append("categoryIds", JSON.stringify(data.categoryIds));
        fd.append("data", JSON.stringify(data.data));
        if (data.isProjectOutput !== undefined)
            fd.append("isProjectOutput", JSON.stringify(data.isProjectOutput));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/media/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/file/media/{fileEntryId}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} contentPostLocationId
        * @param {string[]} categoryIds
        * @param {MediaUploadDto} data
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    CMSController.UpdateMediaFile = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("contentPostLocationId", JSON.stringify(data.contentPostLocationId));
        if (data.categoryIds !== undefined)
            fd.append("categoryIds", JSON.stringify(data.categoryIds));
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/media/{fileEntryId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/file/reference/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} path
        * @param {string} contentPostLocationId
        * @param {string[]} categoryIds
        * @param {string} referenceId
        * @param {boolean} isProjectOutput
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    CMSController.AddMediaReference = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        fd.append("contentPostLocationId", JSON.stringify(data.contentPostLocationId));
        if (data.categoryIds !== undefined)
            fd.append("categoryIds", JSON.stringify(data.categoryIds));
        fd.append("referenceId", JSON.stringify(data.referenceId));
        if (data.isProjectOutput !== undefined)
            fd.append("isProjectOutput", JSON.stringify(data.isProjectOutput));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/reference/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/file/reference/{fileEntryId}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} contentPostLocationId
        * @param {string[]} categoryIds
        * @param {string} referenceId
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    CMSController.UpdateMediaReference = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("contentPostLocationId", JSON.stringify(data.contentPostLocationId));
        if (data.categoryIds !== undefined)
            fd.append("categoryIds", JSON.stringify(data.categoryIds));
        fd.append("referenceId", JSON.stringify(data.referenceId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/reference/{fileEntryId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/file/{fileEntryId}" and http method "DELETE" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {void}
    ******************************************************************************************************/
    CMSController.DeleteContent = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/{fileEntryId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/file/{fileEntryId}/updated" and http method "DELETE" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    CMSController.FileEntryTriggerUpdate = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/{fileEntryId}/updated", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/file/projectOutput/{fileEntryId}/{isProjectOutput}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {boolean} isProjectOutput
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    CMSController.ChangeProjectOutput = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/projectOutput/{fileEntryId}/{isProjectOutput}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/file/archived/{fileEntryId}/{isArchived}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {boolean} isArchived
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    CMSController.ChangeArchived = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/archived/{fileEntryId}/{isArchived}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/search" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {CmsSearchResultDto}
    ******************************************************************************************************/
    CMSController.Search = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/search", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/suggest" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {string} type
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {string[]}
    ******************************************************************************************************/
    CMSController.Suggest = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/suggest", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/historyEntries/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {HistoryEntryDownloadDto[]}
    ******************************************************************************************************/
    CMSController.GetHistoryEntries = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/historyEntries/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/historyData/{entryId}" and http method "GET" to call the back-end.
    
        * @param {string} entryId
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    CMSController.GetHistoryData = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/historyData/{entryId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/cms/history/{entryId}" and http method "POST" to call the back-end.
    
        * @param {string} entryId
        * @returns {void}
    ******************************************************************************************************/
    CMSController.SetCurrentHistoryEntry = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/history/{entryId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return CMSController;
}());
export { CMSController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=CMSController.js.map